export const PLYWOOD_PRODUCTION_DAMAGE_REQUEST = "PLYWOOD_PRODUCTION_DAMAGE_REQUEST";
export const PLYWOOD_PRODUCTION_DAMAGE_SUCCESS = "PLYWOOD_PRODUCTION_DAMAGE_SUCCESS";
export const PLYWOOD_PRODUCTION_DAMAGE_FAILED = "PLYWOOD_PRODUCTION_DAMAGE_FAILED";